import { Flex } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'
import { iNomeId, iParticipanteFeedbackResponse } from '../../../../../interfaces'
import { CircleText } from '../CircleText'
import { TableDiv } from './styles'

interface iTabelaprops {
  rows: iParticipanteFeedbackResponse[]
  colaboradores: iNomeId[]
  onSend: (id: string) => void
  iniciado?: boolean
}

interface iLinhaParticipante {
  participante: iNomeId
  recebido: boolean
}

export const TableParticipantes: React.FC<iTabelaprops> = ({ rows, onSend, colaboradores, iniciado }) => {
  const [Rows, setRows] = useState<iLinhaParticipante[]>([])
  const [Ordenacao, setOrdenacao] = useState(false)
  const [UltimoFiltro, setUltimoFiltro] = useState<number>()

  function OrdenarTabela(filtro: number): void {
    if (!(!Ordenacao && UltimoFiltro !== filtro)) {
      setOrdenacao(!Ordenacao)
    }
    setUltimoFiltro(filtro)
  }
  useEffect(() => {
    const copy = [...Rows]
    if (UltimoFiltro === 1) {
      copy.sort((a, b) => {
        if (!Ordenacao) {
          return b.participante.nome.localeCompare(a.participante.nome)
        } else if (Ordenacao) {
          return a.participante.nome.localeCompare(b.participante.nome)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 2) {
      copy.sort((a, b) => {
        if (!Ordenacao && a.participante.email && b.participante.email) {
          return b.participante?.email.localeCompare(a.participante?.email)
        } else if (Ordenacao && a.participante.email && b.participante.email) {
          return a.participante?.email.localeCompare(b.participante?.email)
        } else {
          return 0
        }
      })
    }
    if (UltimoFiltro === 3) {
      copy.sort((a, b) => {
        if (!Ordenacao) {
          return Number(b.recebido) - Number(a.recebido)
        } else if (Ordenacao) {
          return Number(a.recebido) - Number(b.recebido)
        } else {
          return 0
        }
      })
    }
    setRows(copy)
  }, [Ordenacao, UltimoFiltro])

  useEffect(() => {
    if (rows && colaboradores) {
      const response: iLinhaParticipante[] = []
      rows.forEach(r => {
        r.colaboradoresId.forEach(cid => {
          const colab = colaboradores.find(c => c.id === cid)
          if (colab) {
            response.push({ participante: colab, recebido: r.emailsEnviados.includes(cid) })
          }
        })
      })

      setRows(response)
    }
  }, [rows, colaboradores])

  return (
    <TableDiv>
      <table>
        <thead>
          <tr>
            <th onClick={() => OrdenarTabela(1)}>
              <div>Nome{UltimoFiltro === 1 && !Ordenacao ? <FaChevronUp /> : <FaChevronDown />}</div>
            </th>
            <th onClick={() => OrdenarTabela(2)}>
              <div>Email{UltimoFiltro === 2 && !Ordenacao ? <FaChevronUp /> : <FaChevronDown />}</div>
            </th>
            <th onClick={() => OrdenarTabela(3)}>
              <div>Status {UltimoFiltro === 3 && !Ordenacao ? <FaChevronUp /> : <FaChevronDown />}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          {
            Rows.map((e, i) => {
              return (
                <tr key={i}>
                  <td>{e.participante.nome}</td>
                  <td>{e.participante.email}</td>
                  <td>
                    <Flex justifyContent={'center'} alignItems='center' gap={'.5rem'} flexWrap={'wrap'}>
                      <CircleText fontsize='14px'
                        varColorCircle={!iniciado ? 'Yellow' : e.recebido ? 'Green2' : 'Orange'}
                        varColorText='black'
                      >
                        {!iniciado ? 'Aguardando início do feedback' : e.recebido ? 'Feedback em andamento' : 'Início pendente'}
                      </CircleText>
                    </Flex>
                  </td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </TableDiv>
  )
}
